"use strict";

exports.__esModule = true;
var _TicketWatcherRuleListScreen = require("./TicketWatcherRuleListScreen");
Object.keys(_TicketWatcherRuleListScreen).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _TicketWatcherRuleListScreen[key]) return;
  exports[key] = _TicketWatcherRuleListScreen[key];
});